import { render, staticRenderFns } from "./termsCondition.vue?vue&type=template&id=7d7fb6f7"
import script from "./termsCondition.vue?vue&type=script&lang=js"
export * from "./termsCondition.vue?vue&type=script&lang=js"
import style0 from "./termsCondition.vue?vue&type=style&index=0&id=7d7fb6f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports